import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { LanguageType } from 'src/metronic/core/_config/i18n/language-type.model';
import { LayoutConfigService, ToggleOptions } from '../../../../core/_base/layout';

@Component({
  selector: 'kt-header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrls: ['./header-mobile.component.scss']
})
export class HeaderMobileComponent implements OnInit {
  headerLogo: string;
  asideDisplay: boolean;

  toggleOptions: ToggleOptions = {
    target: 'body',
    targetState: 'kt-header__topbar--mobile-on',
    togglerState: 'kt-header-mobile__toolbar-topbar-toggler--active'
  };

  constructor(
    private layoutConfigService: LayoutConfigService,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.initLogos(LanguageType[this.translateService.getBrowserLang()]);
    this.initLanguageChanges();
    this.initAsideDisplay();
  }


  private initLogos(languageType: LanguageType): void {
    this.headerLogo = this.layoutConfigService.getLogo(languageType, true);
  }

  private initLanguageChanges(): void {
    this.translateService.onLangChange
      .subscribe((lce: LangChangeEvent) => {
        this.initLogos(LanguageType[lce.lang]);
        this.cdr.detectChanges();
      });
  }

  private initAsideDisplay(): void {
    this.asideDisplay = this.layoutConfigService.getConfig('aside.self.display');
  }
}
